module.exports = __webpack_public_path__ + "static/img/banner.ca5346a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 828
// module chunks = 1